const FAQS = [
  {
    question: 'Is this based on real incidents?',
    answer:
      'The game is designed around realistic production failure patterns engineers regularly encounter, including authentication failures, dependency outages, rate limiting, retries, degraded downstream services, and noisy observability signals.',
  },
  {
    question: 'Who is ExplainError Daily for?',
    answer:
      'It is built for SREs, DevOps engineers, platform engineers, backend engineers, cloud engineers, and anyone who wants to improve their incident judgement and production debugging instincts.',
  },
  {
    question: 'Is this just a game?',
    answer:
      'It is a game, but it is also a practical training tool. Each daily challenge helps engineers practise classification, severity assessment, and next-action decision making under realistic conditions.',
  },
  {
    question: 'How long does a challenge take?',
    answer:
      'Most challenges take around 60 seconds. The goal is to make incident thinking easy to practise every day without adding heavy overhead to your routine.',
  },
  {
    question: 'What skills does it help build?',
    answer:
      'ExplainError Daily helps sharpen incident triage, debugging judgement, observability interpretation, and production pattern recognition through small daily reps.',
  },
  {
    question: 'Do I need to sign up to play?',
    answer:
      'No. The current experience is designed to be lightweight and easy to access, so engineers can jump in and start playing immediately.',
  },
  {
    question: 'How often are new incidents added?',
    answer:
      'A new incident challenge is released every day. Each challenge is drawn from a growing library of production-style failure patterns covering networking issues, dependency failures, authentication errors, rate limits, and degraded services.'
  },
  {
    question: 'Why practise incident diagnosis as a game?',
    answer:
      'The fastest way to build operational judgement is through repetition. Small daily exercises train engineers to recognise failure patterns faster and choose better first actions when real incidents occur.'
  }
];

export default function FaqSection() {
  return (
    <section className="py-24 border-t border-border-subtle">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-block text-xs font-mono uppercase tracking-widest text-accent mb-3">
            FAQ
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary">
            Questions engineers may ask
          </h2>
          <p className="text-text-secondary mt-3 max-w-2xl mx-auto text-sm leading-relaxed">
            A quick overview of what ExplainError Daily is, who it is for, and why it is useful.
          </p>
        </div>

        <div className="space-y-4">
          {FAQS.map((item) => (
            <div
              key={item.question}
              className="bg-bg-panel border border-border-subtle rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-text-primary mb-2">
                {item.question}
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}